import { useAuth } from '~/features/auth/AuthProvider'

export const useSupabaseClient = () => {
  return useAuth().supabaseClient
}
